export class DeviceTemplateLambdaTrigger {
    id: string | null = null;
    labelType: string = "NotSpecified";
    lambdaUrl: string = "";
    deviceTemplateId: string = "";

    constructor(init?:Partial<DeviceTemplateLambdaTrigger>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
    }
}
